import React from 'react';
import PropTypes from 'prop-types';

export const chooseAttentionIcon = (type) => {
    let attentionIcon;
    if (type === "success") {
        attentionIcon = "fa-check";
    } else if (type === "warning") {
        attentionIcon = "fa-exclamation-triangle";
    } else if (type === "error"){
        attentionIcon = "fa-ban";
    } else if (type === "info") {
        attentionIcon = "fa-info-circle";
    } else {
        attentionIcon = "fa-exclamation-circle";
    }
    return attentionIcon;
};

class AlertComponent extends React.Component {
    constructor(props){
        super(props);
    }

    componentDidUpdate(prevProps){
        const {message, closeAfterSeconds=10, onClose, scrollIntoView = true} = this.props;
        if (onClose && closeAfterSeconds && message && message !== prevProps.message){
            if (scrollIntoView) {
                this.refs.alertRef.scrollIntoView();
            }
            if (this.state && typeof (this.state.timeOutId) !== "undefined"){
                clearTimeout(this.state.timeOutId);
            }
            const timeOutId = setTimeout(() => {
                this.setState({});
                onClose();
            }, closeAfterSeconds * 1000);
            this.setState({timeOutId});
        }
    }

    render(){
        const {message, type="info", onClose, attention} = this.props;

        if (message) {
            let daMsg;
            if (typeof (message) !== "string" && message.components) {
                // This is instance of ComponentizedMessage
                daMsg = message.components.map(c => {
                    switch (c.type) {
                        case "string":
                            return c.data;
                        case "link":
                            return c.data.targetBlank ? <a href={c.data.href}  target="_blank" >{c.data.label}</a>: <a href={c.data.href} >{c.data.label}</a>
                        default:
                            return "";
                    }
                });
            } else {
                daMsg = message;
            }

            return (
                <div ref="alertRef" className={"alert alert--" + type + " push--bottom"} role="alert">
                    {
                        attention &&
                        <div className="alert__icon">
                            <i className={"fa icon--medium " + chooseAttentionIcon(type)}></i>
                        </div>
                    }
                    {
                        attention ?
                        <div className="alert__heading display--block overflow-wrap--break-word" style={{marginRight:'30px'}}>
                            {daMsg}
                        </div> : daMsg
                    }
                    {
                        onClose &&
                        <div className="alert__close" onClick={onClose}>
                            <i className="fa fa-times-circle"></i>
                        </div>
                    }
                </div>
            );
        } else {
            return "";
        }
    }
}

AlertComponent.propTypes = {
    message: PropTypes.string,
    closeAfterSeconds: PropTypes.number,
    onClose: PropTypes.func,
    attention: PropTypes.bool,
    type: PropTypes.string,
    scrollIntoView: PropTypes.bool
};

AlertComponent.chooseAttentionIcon = chooseAttentionIcon;

export default AlertComponent;